import { Routes } from '@angular/router';
import { LoginComponent } from './core/login/login.component';
import { HomeComponent } from './core/home/home.component';
import { CypherFlyComponent } from './pages/cypher-fly/cypher-fly.component';
import { loginGuard } from './core/guards/login.guard';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'home', component: HomeComponent, canActivate: [loginGuard] },
  { path: 'cypher-fly', component: CypherFlyComponent },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: '**', redirectTo: '/login' },
];
